exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PostCredits__link___U-Eye {\n\ttext-decoration: none;\n\tcolor: inherit;\n    font-weight: bold;\n}\n", ""]);

// exports
exports.locals = {
	"link": "PostCredits__link___U-Eye"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Item/PostCredits.icss
// module id = 1306
// module chunks = 0